// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3s02b","buttons":"Footer_buttons__PH419"};